import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import numeral from 'numeral';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import { colors, typography } from '../../styles';

const styles = css`
  margin-bottom:40px;
  @media (min-width: 768px) {
    margin-bottom:100px;
  }
  .Detail_Stats {
    list-style-type: none;
    padding:0;
    display:flex;
    flex-flow:row wrap;
    justify-content: center;
  }
  .Detail_Stats-item {
    padding:30px;
    text-align: center;
    font:700 20px/1.3 ${typography.SansSerif};
    position: relative;
    @media (min-width: 991px) {
      padding:30px;
      font:700 30px/1.3 ${typography.SansSerif};
    }
    @media (min-width: 1199px) {
      padding:40px;
      font:700 36px/1.3 ${typography.SansSerif};
    }
  }
  .Detail_Stats-item:after {
    content:"";
    background:${colors.color5};
    top:0;
    bottom:0;
    right: 0;
    width:0;
    position: absolute;
    -webkit-transform: skew(-15deg,0);
    transform: skew(-15deg,0);
    @media (min-width: 991px) {
      width:1px;
    }
  }
  .Detail_Stats-item:last-child:after {
    content:"";
    background:${colors.color5};
    top:0;
    bottom:0;
    right: 0;
    width:0px;
    position: absolute;
    -webkit-transform: skew(-15deg,0);
    transform: skew(-15deg,0);
  }
  .Detail_Stats-itemLabel {
    font:700 16px/1.3 ${typography.SansSerif};
    color:${colors.color1};
    text-transform: uppercase;
    display:block;
    margin-bottom: 10px;
    @media (min-width: 991px) {
      font:700 20px/1.3 ${typography.SansSerif};
    }
    @media (min-width: 1199px) {
      font:700 24px/1.3 ${typography.SansSerif};
    }
  }
`;

function PlanDetailStats({ plan }) {
  return (
    <div className={styles}>
      <div className="maxit">
        <ul className="Detail_Stats">
          {get(plan, 'sqft') > 0 &&
            <li className="Detail_Stats-item">
              <span className="Detail_Stats-itemLabel">sqft</span>
              {numeral(get(plan, 'sqft')).format('0,0')}
            </li>
          }
          {get(plan, 'beds') > 0 &&
            <li className="Detail_Stats-item">
              <span className="Detail_Stats-itemLabel">Beds</span>
              {get(plan, 'beds')}
            </li>
          }
          {get(plan, 'bathsFull') > 0 &&
            <li className="Detail_Stats-item">
              <span className="Detail_Stats-itemLabel">Full Baths</span>
              {get(plan, 'bathsFull')}
            </li>
          }
          {get(plan, 'bathsHalf') > 0 &&
            <li className="Detail_Stats-item">
              <span className="Detail_Stats-itemLabel">Half Baths</span>
              {get(plan, 'bathsHalf')}
            </li>
          }
          {get(plan, 'garages') > 0 &&
            <li className="Detail_Stats-item">
              <span className="Detail_Stats-itemLabel">Garages</span>
              {get(plan, 'garages')}
            </li>
          }
          {get(plan, 'stories') > 0 &&
            <li className="Detail_Stats-item">
              <span className="Detail_Stats-itemLabel">Stories</span>
              {get(plan, 'stories')}
            </li>
          }
        </ul>
      </div>
    </div>
  );
}

PlanDetailStats.propTypes = {
  plan: PropTypes.object.isRequired,
};

export default withData(
  {
    plan: true,
  },
  {
    required: {
      plan: true,
    },
  },
)(PlanDetailStats);



// WEBPACK FOOTER //
// ./src/pages/PlanDetail/PlanDetailStats.js